// @flow

// NOTE: This Flow module has a corresponding ambient TypeScript declaration in app/types/flow-modules.d.ts. Keep them in sync until this file is migrated to TypeScript.

import type {PaymentMethod} from '@tectonics/commons/new-payment-methods/payment-method';
import React from 'react';
import {
  DisplayDebitcardBrands,
} from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/payment-method-selector/payment-method-item/display-brands/display-debitcard-brands';
import {debitCardOutgoingPaymentMapper} from '@tectonics/prs/debit-card';
import {CardForm} from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/card-form';

export const DebitcardGuatemala: PaymentMethod = {
  code: 'debitcard',
  nameKey: 'volcanes.debitcard.name',
  placeOrderMessageKey: 'volcanes.debitcard.placeOrder',
  icons: <DisplayDebitcardBrands />,
  outgoingPaymentMapper: debitCardOutgoingPaymentMapper,
  paymentMethodForm: <CardForm />,
};
